/* global gdAlertify */
import React, { useEffect, useState } from "react";
import axiosInstance from "../../config/axiosConfig";
import { mensajeError } from "./enviosUi";

// Recordatorio de los límites de cada proveedor (ver docs/MOTOR_ENVIOS.md del backend).
const AYUDA_LIMITES = {
    gmail: "Gmail gratuito permite 500 correos en 24 h; si se pasa, la cuenta queda bloqueada para enviar hasta 24 h. Deja margen (ej. 400).",
    ycloud: "Meta limita a cuántas personas distintas se escribe con plantilla en 24 h: 250 con la cuenta nueva, 2.000 al verificar la empresa.",
};

const formDesde = (canal) => ({
    nombre: canal.nombre || "",
    remitente: canal.remitente || "",
    remitente_nombre: canal.remitente_nombre || "",
    responder_a: canal.responder_a || "",
    limite_24h: String(canal.limite_24h ?? 0),
    max_por_ciclo: String(canal.max_por_ciclo ?? 25),
    pausa_ms: String(canal.pausa_ms ?? 0),
    max_intentos: String(canal.max_intentos ?? 3),
    activo: Number(canal.activo) === 1,
    es_default: Number(canal.es_default) === 1,
    config: Object.fromEntries((canal.campos || []).map((c) => [c.clave, c.secreto ? "" : String(c.valor ?? "")])),
});

const CanalCard = ({ canal, onGuardado }) => {
    const [form, setForm] = useState(() => formDesde(canal));
    const [guardando, setGuardando] = useState(false);
    const [verificacion, setVerificacion] = useState(null);
    const esWsp = canal.tipo === "whatsapp";

    useEffect(() => setForm(formDesde(canal)), [canal]);

    const set = (campo, valor) => setForm((prev) => ({ ...prev, [campo]: valor }));
    const setConfig = (clave, valor) => setForm((prev) => ({ ...prev, config: { ...prev.config, [clave]: valor } }));

    const guardar = async () => {
        setGuardando(true);
        gdAlertify.showLoader();
        try {
            await axiosInstance.post(`/envios/canales/${canal.id}/guardar`, {
                ...form,
                activo: form.activo ? 1 : 0,
                es_default: form.es_default ? 1 : 0,
            });
            gdAlertify.notiSuccess("Canal guardado.");
            setVerificacion(null);
            onGuardado();
        } catch (error) {
            gdAlertify.notiError(mensajeError(error, "No se pudo guardar el canal."));
        } finally {
            gdAlertify.hideLoader();
            setGuardando(false);
        }
    };

    const verificar = async () => {
        setVerificacion({ cargando: true });
        try {
            const { data } = await axiosInstance.post(`/envios/canales/${canal.id}/verificar`);
            setVerificacion(data?.data || { ok: false, mensaje: "Sin respuesta." });
        } catch (error) {
            setVerificacion({ ok: false, mensaje: mensajeError(error, "No se pudo verificar el canal.") });
        }
    };

    const copiar = (texto) => {
        navigator.clipboard?.writeText(texto);
        gdAlertify.notiSuccess("URL copiada.");
    };

    return (
        <div className="card mb-4">
            <div className="card-header d-flex justify-content-between align-items-center">
                <strong>
                    <i className={`bi ${esWsp ? "bi-whatsapp text-success" : "bi-envelope text-primary"} me-2`}></i>
                    {canal.nombre} <small className="text-muted fw-normal ms-1">{canal.codigo}</small>
                </strong>
                <div className="d-flex gap-3">
                    <div className="form-check form-switch mb-0">
                        <input className="form-check-input" type="checkbox" id={`activo-${canal.id}`} checked={form.activo} onChange={(e) => set("activo", e.target.checked)} />
                        <label className="form-check-label" htmlFor={`activo-${canal.id}`}>Activo</label>
                    </div>
                    <div className="form-check form-switch mb-0">
                        <input className="form-check-input" type="checkbox" id={`default-${canal.id}`} checked={form.es_default} onChange={(e) => set("es_default", e.target.checked)} />
                        <label className="form-check-label" htmlFor={`default-${canal.id}`}>Por defecto</label>
                    </div>
                </div>
            </div>

            <div className="card-body">
                <div className="row g-3">
                    <div className="col-md-4">
                        <label className="form-label">Nombre</label>
                        <input className="form-control" value={form.nombre} onChange={(e) => set("nombre", e.target.value)} />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">{esWsp ? "Número emisor" : "Correo remitente"}</label>
                        <input className="form-control" value={form.remitente} placeholder={esWsp ? "+56912345678" : "correo@gmail.com"}
                            onChange={(e) => set("remitente", e.target.value)} />
                        {esWsp && <div className="form-text">El número de WhatsApp Business registrado en YCloud.</div>}
                    </div>
                    {!esWsp && (
                        <>
                            <div className="col-md-4">
                                <label className="form-label">Nombre del remitente</label>
                                <input className="form-control" value={form.remitente_nombre} onChange={(e) => set("remitente_nombre", e.target.value)} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Responder a</label>
                                <input className="form-control" value={form.responder_a} onChange={(e) => set("responder_a", e.target.value)} />
                                <div className="form-text">Las respuestas llegan a esta bandeja.</div>
                            </div>
                        </>
                    )}
                </div>

                <h6 className="fw-semibold mt-4">Límites</h6>
                <div className="row g-3">
                    <div className="col-md-3">
                        <label className="form-label">Máximo en 24 h</label>
                        <input type="number" min="0" className="form-control" value={form.limite_24h} onChange={(e) => set("limite_24h", e.target.value)} />
                        <div className="form-text">0 = sin límite propio.</div>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Máximo por ciclo (5 min)</label>
                        <input type="number" min="1" className="form-control" value={form.max_por_ciclo} onChange={(e) => set("max_por_ciclo", e.target.value)} />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Pausa entre mensajes (ms)</label>
                        <input type="number" min="0" step="100" className="form-control" value={form.pausa_ms} onChange={(e) => set("pausa_ms", e.target.value)} />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Intentos máximos</label>
                        <input type="number" min="1" max="10" className="form-control" value={form.max_intentos} onChange={(e) => set("max_intentos", e.target.value)} />
                    </div>
                </div>
                <div className="form-text mb-2"><i className="bi bi-info-circle me-1"></i>{AYUDA_LIMITES[canal.proveedor]}</div>

                <h6 className="fw-semibold mt-4">Conexión con {canal.proveedor === "gmail" ? "Gmail" : "YCloud"}</h6>
                <div className="row g-3">
                    {(canal.campos || []).map((c) => (
                        <div className="col-md-6" key={c.clave}>
                            <label className="form-label">{c.etiqueta}</label>
                            {c.tipo === "select" ? (
                                <select className="form-select" value={form.config[c.clave] ?? ""} onChange={(e) => setConfig(c.clave, e.target.value)}>
                                    {(c.opciones || []).map((o) => <option key={o} value={o}>{o}</option>)}
                                </select>
                            ) : (
                                <input
                                    type={c.tipo === "password" ? "password" : c.tipo === "number" ? "number" : "text"}
                                    className="form-control"
                                    autoComplete="new-password"
                                    value={form.config[c.clave] ?? ""}
                                    placeholder={c.secreto ? (c.configurado ? `Configurado (${c.pista}). Deja vacío para mantenerlo` : "Sin configurar") : ""}
                                    onChange={(e) => setConfig(c.clave, e.target.value)}
                                />
                            )}
                            {c.secreto && (
                                <span className={`badge mt-1 ${c.configurado ? "bg-success" : "bg-secondary"}`}>
                                    {c.configurado ? "Guardado cifrado" : "Pendiente"}
                                </span>
                            )}
                            {c.ayuda && <div className="form-text">{c.ayuda}</div>}
                        </div>
                    ))}
                </div>

                {canal.webhook_url && (
                    <div className="alert alert-light border mt-4 mb-0">
                        <div className="fw-semibold mb-1"><i className="bi bi-link-45deg me-1"></i>Webhook para YCloud</div>
                        <div className="input-group input-group-sm mb-2">
                            <input className="form-control font-monospace" readOnly value={canal.webhook_url} />
                            <button className="btn btn-outline-secondary" onClick={() => copiar(canal.webhook_url)}>
                                <i className="bi bi-clipboard"></i>
                            </button>
                        </div>
                        <small className="text-muted">
                            En YCloud &gt; Developers &gt; Webhooks crea un endpoint con esta URL y el evento <code>whatsapp.message.updated</code>.
                            Copia el secreto que te entrega y pégalo arriba en <strong>Secreto del webhook</strong>. Así llegan los estados Entregado, Leído y Fallido.
                        </small>
                    </div>
                )}

                {verificacion && !verificacion.cargando && (
                    <div className={`alert ${verificacion.ok ? "alert-success" : "alert-danger"} mt-3 mb-0 py-2`}>
                        <i className={`bi ${verificacion.ok ? "bi-check-circle" : "bi-x-circle"} me-1`}></i>
                        {verificacion.mensaje}
                    </div>
                )}
            </div>

            <div className="card-footer d-flex justify-content-end gap-2">
                <button className="btn btn-outline-secondary" onClick={verificar} disabled={verificacion?.cargando}
                    title="Prueba la conexión con lo que está guardado">
                    {verificacion?.cargando ? <span className="spinner-border spinner-border-sm me-1"></span> : <i className="bi bi-plug me-1"></i>}
                    Probar conexión
                </button>
                <button className="btn btn-primary" onClick={guardar} disabled={guardando}>
                    <i className="bi bi-save me-1"></i>Guardar
                </button>
            </div>
        </div>
    );
};

const EnviosCanales = ({ onGuardado }) => {
    const [canales, setCanales] = useState([]);
    const [loading, setLoading] = useState(true);

    const cargar = async () => {
        try {
            const { data } = await axiosInstance.get("/envios/canales");
            setCanales(data?.data || []);
        } catch (error) {
            gdAlertify.notiError(mensajeError(error, "No se pudieron cargar los canales."));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        cargar();
    }, []);

    if (loading) {
        return <div className="text-center py-4"><div className="spinner-border text-primary" role="status"></div></div>;
    }

    return (
        <>
            <div className="alert alert-info">
                <i className="bi bi-shield-lock me-2"></i>
                Las contraseñas y API keys se guardan <strong>cifradas</strong> y nunca se muestran de vuelta.
                Guarda primero y después usa <strong>Probar conexión</strong>. Un canal <strong>inactivo</strong> no envía
                lo que esté en la cola, pero sí permite envíos de prueba.
            </div>
            {canales.map((c) => (
                <CanalCard key={c.id} canal={c} onGuardado={() => { cargar(); onGuardado?.(); }} />
            ))}
        </>
    );
};

export default EnviosCanales;
